export enum ChartSortTypes {
    NATURAL = 'NATURAL',
    AGGREGATION = 'AGGREGATION'
}
